<template>
    <div id="building-preference-form">
        <v-card>
            <v-card-title>
                <v-icon left :color="kingsGold">mdi-home-group</v-icon>Building Preferences
            </v-card-title>
            <v-alert v-if="alert" :color="dangerColor" class="mr-3 ml-3 mb-0" dense icon="mdi-alert-circle" text
                prominent>
                There are one or more required form fields that are empty. Please verify that all required form fields
                are filled in.
            </v-alert>
            <v-card-text>
                <v-form ref="buildingPreferenceForm" v-model="valid" lazy-validation>
                    <v-container class="px-0" fluid>
                        <v-card-subtitle class="pb-1 px-0">
                            <v-icon :color="kingsGold" left>mdi-home-group</v-icon>Building Preference (Please rank
                            three)
                        </v-card-subtitle>
                        <v-alert :color="infoColor" dense icon="mdi-information" text>
                            <b>Please note:</b>
                            <ul>
                                <li>
                                    <b>Monsignor
                                        Wemple</b> residence is designated to female only.
                                </li>
                                <li>
                                    Keep in mind that Managers will make placements based on the needs of the residence
                                    program.
                                </li>
                            </ul>
                        </v-alert>
                        <v-row>
                            <v-col cols="12" lg="6">
                                <v-card-subtitle class="pa-0">
                                    <v-icon :color="kingsGold" left>mdi-home-floor-1</v-icon>Building - First Choice
                                </v-card-subtitle>
                                <v-select v-model="applicant.buildingOption01" :items="getBuildingsOptionOne"
                                    label="Building Preference" :rules="buildingOption01Rules" required>
                                </v-select>
                                <v-text-field v-model="applicant.buildingUnit01" hide-details
                                    label="Please indicate which unit(s) you would prefer (not required)">
                                </v-text-field>
                                <v-text-field v-model="applicant.buildingPartner01"
                                    label="Please indicate any preferred Residence Assistant partner (not required)">
                                </v-text-field>
                                <v-btn class="white--text" :color="infoColor" :disabled="getBuildingsOptionOneFile()"
                                    small tile @click="getBuildingsOptionOneFileLink()">Download Contract Conditions
                                </v-btn>
                                <v-checkbox v-model="applicant.buildingContractCondition01" false-value="0"
                                    :rules="buildingContractConditionRules"
                                    label="I have read and agree to the contract conditions" true-value="1" required>
                                </v-checkbox>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <v-card-subtitle class="pa-0">
                                    <v-icon :color="kingsGold" left>mdi-home-floor-2</v-icon>Building - Second Choice
                                </v-card-subtitle>
                                <v-select v-model="applicant.buildingOption02" :items="getBuildingsOptionTwo"
                                    label="Building Preference" :rules="buildingOption02Rules" required>
                                </v-select>
                                <v-text-field v-model="applicant.buildingUnit02" hide-details
                                    label="Please indicate which unit(s) you would prefer (not required)">
                                </v-text-field>
                                <v-text-field v-model="applicant.buildingPartner02"
                                    label="Please indicate any preferred Residence Assistant partner (not required)">
                                </v-text-field>
                                <v-btn class="white--text" :color="infoColor" :disabled="getBuildingsOptionTwoFile()"
                                    small tile @click="getBuildingsOptionTwoFileLink()">Download Contract Conditions
                                </v-btn>
                                <v-checkbox v-model="applicant.buildingContractCondition02" false-value="0"
                                    :rules="buildingContractConditionRules"
                                    label="I have read and agree to the contract conditions" true-value="1" required>
                                </v-checkbox>
                            </v-col>
                            <v-col cols="12" lg="6" v-if="getBuildingsOptionThree.length > 0">
                                <v-card-subtitle class="pa-0">
                                    <v-icon :color="kingsGold" left>mdi-home-floor-3</v-icon>Building - Third Choice
                                </v-card-subtitle>
                                <v-select v-model="applicant.buildingOption03" :items="getBuildingsOptionThree"
                                    label="Building Preference" :rules="buildingOption03Rules" required>
                                </v-select>
                                <v-text-field v-model="applicant.buildingUnit03" hide-details
                                    label="Please indicate which unit(s) you would prefer (not required)">
                                </v-text-field>
                                <v-text-field v-model="applicant.buildingPartner03"
                                    label="Please indicate any preferred Residence Assistant partner (not required)">
                                </v-text-field>
                                <v-btn class="white--text" :color="infoColor" :disabled="getBuildingsOptionThreeFile()"
                                    small tile @click="getBuildingsOptionThreeFileLink()">Download Contract Conditions
                                </v-btn>
                                <v-checkbox v-model="applicant.buildingContractCondition03" false-value="0"
                                    :rules="buildingContractConditionRules"
                                    label="I have read and agree to the contract conditions" true-value="1" required>
                                </v-checkbox>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="applicant.buildingUnitPreference"
                                    :items="buildingUnitPreferenceItems" label="Unit Preference"
                                    placeholder="Please select..." :rules="buildingUnitPreferenceRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-basket</v-icon>Meal Plan Information
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-select v-model="applicant.residenceMealPlan"
                                    hint="Note: These costs are approximate. Final costs are subject to Board approval."
                                    :items="getResidenceMealPlanItems" label="Meal Plan" persistent-hint
                                    placeholder="Please select..." :rules="residenceMealPlanRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn class="white--text" :color="successColor" :disabled="!valid" @click="nextStep(4)">
                    Next
                </v-btn>
                <v-btn class="white--text" :color="kingsGrey" @click="prevStep(2)">
                    Previous
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'residence-assistant-building-preference-form',
    props: {
        applicant: {
            required: true
        },
        formSettings: {
            required: true
        },
        user: {
            required: true
        }
    },
    data() {
        return {
            alert: false,
            buildingContractConditionRules: [
                v => !!v || ''
            ],
            buildingOption01Rules: [
                v => !!v || 'First choice building preference is required'
            ],
            buildingOption02Rules: [
                v => !!v || 'Second choice building preference is required'
            ],
            buildingOption03Rules: [
                v => !!v || 'Third choice building preference is required'
            ],
            buildingUnitPreferenceItems: [{
                    text: 'Single Gender Unit',
                    value: 'Single Gender Unit'
                },
                {
                    text: 'Mixed Gender Unit',
                    value: 'Mixed Gender Unit'
                },
            ],
            buildingUnitPreferenceRules: [
                v => !!v || 'Unit preference is required'
            ],
            genders: {
                F: 'Female',
                M: 'Male',
                NonBinary: 'Non-Binary'
            },
            residenceMealPlanRules: [
                v => !!v || 'Residence meal plan is required'
            ],
            valid: true
        }
    },
    methods: {
        getBuildingsOptionOneFile() {
            let option = this.applicant.buildingOption01;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            if (building && building.fileContractConditions && building.fileContractConditions.file && building.fileContractConditions.fileNormalized) {
                return false;
            }

            return true;
        },
        getBuildingsOptionOneFileLink() {
            let option = this.applicant.buildingOption01;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            let data = JSON.stringify({
                file: building.fileContractConditions.file,
                fileNormalized: building.fileContractConditions.fileNormalized
            });

            window.open(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?download&data=${data}`);
        },
        getBuildingsOptionTwoFile() {
            let option = this.applicant.buildingOption02;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            if (building && building.fileContractConditions && building.fileContractConditions.file && building.fileContractConditions.fileNormalized) {
                return false;
            }

            return true;
        },
        getBuildingsOptionTwoFileLink() {
            let option = this.applicant.buildingOption02;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            let data = JSON.stringify({
                file: building.fileContractConditions.file,
                fileNormalized: building.fileContractConditions.fileNormalized
            });

            window.open(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?download&data=${data}`);
        },
        getBuildingsOptionThreeFile() {
            let option = this.applicant.buildingOption03;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            if (building && building.fileContractConditions && building.fileContractConditions.file && building.fileContractConditions.fileNormalized) {
                return false;
            }

            return true;
        },
        getBuildingsOptionThreeFileLink() {
            let option = this.applicant.buildingOption03;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            let data = JSON.stringify({
                file: building.fileContractConditions.file,
                fileNormalized: building.fileContractConditions.fileNormalized
            });

            window.open(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?download&data=${data}`);
        },
        nextStep(val) {
            if (this.$refs.buildingPreferenceForm.validate()) {
                this.alert = false;
                this.$emit('setStep', val);
                this.$nextTick(() => {
                    this.$emit('scrollToTop');
                })
            } else {
                this.alert = true;
                this.$emit('scrollToTop');
            }
        },
        prevStep(val) {
            this.$emit('setStep', val);
            this.$nextTick(() => {
                this.$emit('scrollToTop');
            })
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        getBuildingsOptionOne() {
            let buildings = this.user.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.applicant.gender] || '';
            let reg = new RegExp(`^${gender}`, 'i');

            for (let i = 0; i < buildings.length; i++) {
                let genderBool = false;
                let yearBool = true;
                let internationalBool = true;

                // Gender restriction check
                if (gender && buildings[i].genderRestriction.length > 0) {
                    let restrictions = buildings[i].genderRestriction;

                    for (let j = 0; j < restrictions.length; j++) {
                        if (restrictions[j].match(reg)) {
                            genderBool = true;
                            break;
                        }
                    }
                } else if (gender) {
                    genderBool = true;
                }

                //2025 November Update (KUC-10459): RAs only can choose 1st year buildings, except International House
                if (parseInt(buildings[i].minYearOfStudy) > 1) {
                    yearBool = false;
                }

                //2025 November Update (KUC-10459):  International restriction check (RAs don't live in International House)
                if (buildings[i].internationalOnly == "1") {
                    internationalBool = false;
                }

                if (genderBool && internationalBool && yearBool) {
                    currentBuildings.push({
                        text: buildings[i].name,
                        value: buildings[i].name
                    });
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingsOptionTwo() {
            let buildings = this.user.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.applicant.gender] || '';
            let reg = new RegExp(`^${gender}`, 'i');
            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name != this.applicant.buildingOption01) {
                    let genderBool = false;
                    let yearBool = true;
                    let internationalBool = true;

                    // Gender restriction check
                    if (gender && buildings[i].genderRestriction.length > 0) {
                        let restrictions = buildings[i].genderRestriction;

                        for (let j = 0; j < restrictions.length; j++) {
                            if (restrictions[j].match(reg)) {
                                genderBool = true;
                                break;
                            }
                        }
                    } else if (gender) {
                        genderBool = true;
                    }

                    //2025 November Update (KUC-10459): RAs only can choose 1st year buildings, except International House
                    if (parseInt(buildings[i].minYearOfStudy) > 1) {
                        yearBool = false;
                    }

                    //2025 November Update (KUC-10459):  International restriction check (RAs don't live in International House)
                    if (buildings[i].internationalOnly == "1") {
                        internationalBool = false;
                    }

                    if (genderBool && yearBool && internationalBool) {
                        currentBuildings.push({
                            text: buildings[i].name,
                            value: buildings[i].name
                        });
                    }
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingsOptionThree() {
            let buildings = this.user.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.applicant.gender] || '';
            let reg = new RegExp(`^${gender}`, 'i');
            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name != this.applicant.buildingOption01 && buildings[i].name != this.applicant.buildingOption02) {
                    let genderBool = false;
                    let yearBool = true;
                    let internationalBool = true;

                    // Gender restriction check
                    if (gender && buildings[i].genderRestriction.length > 0) {
                        let restrictions = buildings[i].genderRestriction;

                        for (let j = 0; j < restrictions.length; j++) {
                            if (restrictions[j].match(reg)) {
                                genderBool = true;
                                break;
                            }
                        }
                    } else if (gender) {
                        genderBool = true;
                    }

                    //2025 November Update (KUC-10459): RAs only can choose 1st year buildings, except International House
                    if (parseInt(buildings[i].minYearOfStudy) > 1) {
                        yearBool = false;
                    }

                    //2025 November Update (KUC-10459):  International restriction check (RAs don't live in International House)
                    if (buildings[i].internationalOnly == "1") {
                        internationalBool = false;
                    }

                    if (genderBool && internationalBool && yearBool) {
                        currentBuildings.push({
                            text: buildings[i].name,
                            value: buildings[i].name
                        });
                    }
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getResidenceMealPlanItems() {
            let buildings = this.user.buildings || [];
            let mealPlanItems = [...this.formSettings.mealPlans];
            let required = false;

            // Slice
            mealPlanItems.length = 3;

            if (this.applicant.buildingOption01 || this.applicant.buildingOption02) {
                for (let i = 0; i < buildings.length; i++) {
                    if ((buildings[i].name == this.applicant.buildingOption01 || buildings[i].name == this.applicant.buildingOption02) && buildings[i].mealPlanRequired == "1") {
                        required = true;
                        break;
                    }
                }
            }

            // Required meal plan
            if (required) {
                return mealPlanItems;
            }

            return this.formSettings.mealPlans;
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.col-12 {
    padding-top: 0;
}
</style>